<template>
  <div class="authpage">
    <the-header />
    <div class="body">
      <router-view />
    </div>
  </div>
</template>

<script>
import TheHeader from '../components/TheHeader.vue'
export default {
  components: { TheHeader },

}
</script>

<style lang="less">
.authpage{
  height: 100%;
  display: flex;
  flex-direction: column;
  .body{
    flex:1 1 auto;
    color:white;
    text-align:center;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 400px);
    width: 100%;
    background-image: url(/images/texture2.png);
    background-size: auto;
    background-position: center top;
    background-repeat:  repeat-x;
    background-color: #000000;
  }
}
</style>